import { createRoutine } from 'redux-saga-routines'
import { createRoutineReducer } from '../framework/routineReducer'

//No need to have this in actionCeators - just a nice way to group stuff.
export const actionCreators = {
    getMarketAnalysis: createRoutine('MARKET_ANALYSIS')
};

export const reducer = createRoutineReducer(actionCreators.getMarketAnalysis);
